module.exports = __webpack_public_path__ + "static/media/tabletcard.96ec9c25.svg";